const LETTERS = /^\p{L}{2,}$/u;
const VOWELS = /[aeiouyàáâäåãæèéêëìíîïòóôöõøùúûüý]/iu;

/**
 * A readable artist name from the signup stand-in (the email local part): no `+tag`, dots,
 * dashes and underscores become spaces, digits at the start or end of a word go, and each word
 * starts with a capital. `mike` gives "Mike", `john.doe92+music24` gives "John Doe".
 * It gives '' when the local part does not look like a name: a word with a digit inside or a
 * word with no vowel (an Apple relay id such as `k8x7vq2bpt`), a word under 2 letters, or the
 * signup fallback `user`. The field then starts empty.
 */
export function suggestedArtistName(standIn: string): string {
  const [localPart = ''] = standIn.split('+');
  const words = localPart
    .split(/[\s._-]+/)
    .map((word) => word.replace(/^[0-9]+|[0-9]+$/g, ''))
    .filter((word) => word !== '');
  if (words.length === 0 || words.some((word) => !LETTERS.test(word) || !VOWELS.test(word))) {
    return '';
  }
  const name = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  return name.toLowerCase() === 'user' ? '' : name;
}
